import { Base } from "./base";
import { camelToSnakeCase, isObject } from "@pineapplelab/util";
import firebase from "firebase/compat/app";
import { Timestamp } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import 'reflect-metadata';

export abstract class FBase<T=any> extends Base {

  private __createdAt: firebase.firestore.Timestamp | firebase.firestore.FieldValue = serverTimestamp();
  private __updatedAt: firebase.firestore.Timestamp | firebase.firestore.FieldValue = serverTimestamp();
  private __createdAtTimestamp: firebase.firestore.Timestamp = firebase.firestore.Timestamp.now();
  private __updatedAtTimestamp: firebase.firestore.Timestamp = firebase.firestore.Timestamp.now();
  deletedAt: Object = null;
  createdBy: string = null;
  updatedBy: string = null;
  deletedBy: string = null;
  isDeleted: boolean = false;
  isHidden: boolean = false;
  id: string = null;

  set createdAt(timestamp: any) {
    this.__createdAt = timestamp;
  }

  get createdAt() {
    return this.__createdAt;
  }

  set updatedAt(timestamp: any) {
    this.__updatedAt = timestamp;
  }

  get updatedAt() {
    return this.__updatedAt;
  }

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }

    if (json?.["createdBy"]) {
      this.createdBy = json["createdBy"];
    }

    if (json?.["deletedBy"]) {
      this.deletedBy = json["deletedBy"];
    }
  }
  override toJson(camelCase = false) {
    const json = super.toJson(camelCase);

    if (!json.created_at) {
      json.created_at = this.__createdAt;
    }

    json.updated_at = firebase.firestore.FieldValue.serverTimestamp();

    if (!json.is_deleted) {
      json.is_deleted = false;
    }

    this.dateToTimestamp(json);
    return json;
  }

  public getMetadata(): string[] {
    const DATE_PROP_KEY = 'dateProperties';
    return Reflect.getMetadata(DATE_PROP_KEY, this) || [];
  }

  dateToTimestamp(json: { [key: string]: any }) {
    this.getMetadata()
      .map(meta => camelToSnakeCase(meta))
      .forEach(prop => {
        let timestampInstance: Timestamp = null;

        if (json[prop] instanceof Date) {
          timestampInstance = Timestamp.fromDate(json[prop]);
        }

        if (typeof json[prop] == 'string') {
          timestampInstance = Timestamp.fromDate(new Date(json[prop]));
        }

        json[prop] = timestampInstance;
      });
  }

  fieldValueToTimestamp(): void {
	this.__createdAt = this.__createdAtTimestamp;
	this.__updatedAt = this.__updatedAtTimestamp;
  }
}
